import get from 'lodash-es/get'
import isEmpty from 'lodash-es/isEmpty'

import { createBuildingGroup } from '../../../api'
import { useInlineNotifications } from '../../../hooks'
import { parseServerValidation } from '../../../utils/validation'
import { FormikForm } from '../../Formik'

import { BUILDING_GROUP_FORM_INITIAL_VALUES } from './BuildingGroupForm.constants'
import { getPayload, getValidationSchema } from './BuildingGroupForm.utils'
import { FormFields } from './FormFields'

import * as styles from './BuildingGroupForm.module.css'

function BuildingGroupForm({
  FormContainer,
  containerProps,
  initialValues = BUILDING_GROUP_FORM_INITIAL_VALUES,
  onSuccess,
  ...restProps
}) {
  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema = getValidationSchema()

  function handleSubmit(values, { setErrors, setSubmitting }) {
    const payload = getPayload(values)

    createBuildingGroup(payload)
      .then(({ data }) => {
        onSuccess?.(data)
      })
      .catch(error => {
        const errors = get(error, ['response', 'data'], {})

        if (!isEmpty(errors)) {
          setSubmitting(false)
          setErrors(parseServerValidation(errors))
        }
      })
  }

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={containerProps}
      formProps={{
        className: styles.formBody,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <FormFields
        {...restProps}
        notifications={notifications}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default BuildingGroupForm
